import { API_STATES } from "@/helpers";

const state = {
  adminUsersGetState             : API_STATES.NOT_REQUESTED,
  adminUsersGetError             : null,
  sendResetPasswordState         : API_STATES.NOT_REQUESTED,
  sendResetPasswordError         : null,
  adminUserDeleteState           : API_STATES.NOT_REQUESTED,
  adminUserDeleteError           : null,
  adminUsers                     : [],
  usersCount                     : 0,
  assignRevokeAdminRightsPending : [],
  assignRevokeAdminRightsError   : null
};

export default state;